import React, { useState, useEffect } from "react";
import { X, Bug, Loader2 } from "lucide-react";
import { query, collection, where, limit, getDocs } from "firebase/firestore";
import { db } from "../../config/firebase";
import { appId } from "../../config/constants";

const MyIssuesModal = ({ user, onClose }) => {
    const [issues, setIssues] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user) return;
        const q = query(
            collection(db, "artifacts", appId, "public", "data", "issues"),
            where("userId", "==", user.uid),
            limit(20)
        );
        getDocs(q).then(snap => {
            setIssues(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            setLoading(false);
        }).catch(err => {
            console.error(err);
            setLoading(false);
        });
    }, [user]);

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
            <div className="bg-white rounded-[2rem] w-full max-w-sm h-[70vh] flex flex-col shadow-2xl relative" onClick={e => e.stopPropagation()}>
                <div className="bg-slate-900 p-6 text-white relative shrink-0 rounded-t-[2rem]">
                    <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
                    <h3 className="text-xl font-black tracking-wide flex items-center gap-2"><Bug size={24} className="text-orange-400"/> 我的回報紀錄</h3>
                </div>
                <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50">
                    {loading ? <div className="text-center text-slate-400 mt-10"><Loader2 className="animate-spin inline"/> 讀取中...</div> : 
                     issues.length === 0 ? <div className="text-center text-slate-400 mt-10">尚無回報紀錄</div> :
                     issues.map(issue => (
                        <div key={issue.id} className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm">
                            <div className="flex justify-between items-start mb-2">
                                <span className={`text-[10px] px-2 py-1 rounded-full font-bold ${issue.isResolved ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'}`}>
                                    {issue.isResolved ? '✅ 已解決' : '🕒 處理中'}
                                </span>
                                <span className="text-[10px] text-slate-400 font-mono">{issue.timestamp?.toDate().toLocaleDateString()}</span>
                            </div>
                            <p className="text-sm text-slate-700 font-bold mb-1">【{issue.type === 'error' ? '系統錯誤' : '問題回報'}】</p>
                            <p className="text-xs text-slate-500 line-clamp-2">{issue.description}</p>
                        </div>
                     ))}
                </div>
            </div>
        </div>
    );
};

export default MyIssuesModal;
